
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products",
      function () {
        return require("private-next-pages/products/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/products"])
      });
    }
  